// @flow
const MATCH = 'match';
const PLAY = 'match:play';
const STOP = 'match:stop';
const WIN = 'match:win';

const START_SESSION = 'match:start-session';
const START_NEXT_BATCH = 'match:nextBatch';
const STOP_SESSION = 'match:stop-session';
const COMPLETE_SESSION = 'match:session-complete';

export {
  START_NEXT_BATCH,
  COMPLETE_SESSION,
  MATCH,
  PLAY,
  START_SESSION,
  STOP_SESSION,
  STOP,
  WIN,
};
